import React from "react";
import config from "../../../config";
import classNames from "classnames";

export default function GooglePlayStoreLink({
  href,
  tabIndex,
  className,
}: {
  href?: string;
  tabIndex?: number;
  className?: string;
}) {
  const googlePlayStoreImageUrl = `${config.ASSETS_URL}/static/google-play-badge-2025.png`;

  if (!href) {
    return (
      <img
        className={classNames(className?.includes("tw-h-") ? className : classNames("tw-h-[40px]", className))}
        src={googlePlayStoreImageUrl}
        alt='Get it on Google Play'
      />
    );
  }

  return (
    <a href={href} target='_blank' rel='noopener noreferrer' tabIndex={tabIndex}>
      <img
        className={classNames(className?.includes("tw-h-") ? className : classNames("tw-h-[40px]", className))}
        src={googlePlayStoreImageUrl}
        alt='Get it on Google Play'
      />
    </a>
  );
}
